import { DeviceInfo } from '../types';

interface ApiDeviceInfo {
  machineName: string;
  osVersion: string;
  appVersion: string;
  installId: string;
}

export async function getDeviceInfo(): Promise<ApiDeviceInfo> {
  // Get browser platform info
  const platform = navigator.platform;
  let osVersion = 'Unknown';
  
  // Detect OS version from user agent
  const userAgent = navigator.userAgent;
  if (userAgent.indexOf('Win') !== -1) {
    if (userAgent.indexOf('Windows NT 10.0') !== -1) osVersion = 'Windows 10';
    else if (userAgent.indexOf('Windows NT 6.3') !== -1) osVersion = 'Windows 8.1';
    else if (userAgent.indexOf('Windows NT 6.2') !== -1) osVersion = 'Windows 8';
    else osVersion = 'Windows';
  } else if (userAgent.indexOf('Mac') !== -1) {
    osVersion = 'macOS';
  } else if (userAgent.indexOf('Linux') !== -1) {
    osVersion = 'Linux';
  } else if (userAgent.indexOf('Android') !== -1) {
    osVersion = 'Android';
  } else if (userAgent.indexOf('iOS') !== -1 || userAgent.indexOf('iPhone') !== -1) {
    osVersion = 'iOS';
  }

  // Get or generate install ID from localStorage
  let installId = localStorage.getItem('installId');
  if (!installId) {
    installId = process.env.NODE_ENV === 'development' 
      ? 'fc2f1e3b-d4e8-434d-915b-48990b125df7' // Use test install ID in dev
      : generateUUID();
    localStorage.setItem('installId', installId);
  }

  const deviceInfo: ApiDeviceInfo = {
    machineName: `${platform}-${window.location.hostname}`,
    osVersion: osVersion,
    appVersion: '1.0.0', // PWA version
    installId: installId
  };

  return deviceInfo;
}

function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export function getDeviceFingerprint(deviceInfo: DeviceInfo): string {
  const data = `${deviceInfo.userAgent}|${deviceInfo.platform}|${deviceInfo.screenResolution}|${deviceInfo.timezone}|${deviceInfo.webglRenderer || ''}`;
  return btoa(data);
}